export default class BlockTestimonies {
	static init() {

		let blocks = document.querySelectorAll('.block-testimonies');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper');
			const pagination = block.querySelector('.swiper-pagination');
			const navigation = block.querySelector('.swiper-navigation');
			new Swiper(swiper, {
				slidesPerView: "1",
				grabCursor: true,
				speed: 800,
				effect: 'creative',
				creativeEffect: {
					prev: {
						translate: ['-150%', 0, -400],
						opacity: 0
					},
					next: {
						translate: ['150%', 0, -400],
						opacity: 0
					}
				},
				navigation: {
					nextEl: '.swiper-btn-next',
					prevEl: '.swiper-btn-prev'
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				}
			});
		});
	}
}
